<template>
  <toggle-button
    v-model="value"
    :disabled="!isConnectionOk"
    :sync="true"
  />
</template>

<script>
import BaseControlMixin from '@/components/controls/mixins/BaseControl';

export default {
  name: 'SliderSwitch',
  mixins: [
    BaseControlMixin,
  ],
  isInline: true,
  computed: {
    value: {
      get() {
        return this.getSingleVar.value;
      },
      set(value) {
        this.handleControl(value);
      },
    },
  },
};
</script>

<style scoped>

</style>
